import { render, staticRenderFns } from "./UserManageSave.vue?vue&type=template&id=c4fbef70&scoped=true"
import script from "./UserManageSave.vue?vue&type=script&lang=js"
export * from "./UserManageSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4fbef70",
  null
  
)

export default component.exports